import { useContext } from 'react';
import { IThreadHistory, ThreadHistoryContext } from '@/contexts/thread-history/helpers';

const useThreadHistory = () => useContext<IThreadHistory>(ThreadHistoryContext);

export default useThreadHistory;
